import {
  HttpRequest,
  apiUrl
} from "@/utils/http";

let PublicModule = {
  getFoodSelect: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/select`,
      data: datas
    });
  },
  getFoodSelectByCat: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/food/selectByCat`,
      data: datas
    });
  },
  getGradeSelect: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/grade/select`,
      data: datas
    });
  },
  getClassSelect: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/class/select`,
      data: datas
    });
  },
  getDinerSelect: function (datas) {
    return HttpRequest.getRequest({
      method: "POST",
      url: `${apiUrl}/diner/select`,
      data: datas
    });
  },
}

export {
  PublicModule
}